import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { DialogService } from '@services/dialog/dialog.service';
import { Models } from '@ibexfusion/models';
import { AccommodationWizardIdsService } from '@services/accommodation-wizard-ids-service/accommodation-wizard-ids.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { RoleService } from '@services/roles/role.service';
import { GroupService } from '@services/groups/group.service';
import { GroupHasProfileService } from '@services/groups/group-has-profile.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { PackageService } from '@services/packages/package.service';
import { ProfileService } from '@services/profiles/profile.service';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';
import { FileAssetsService } from '@services/assets/file-assets.service';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { VideoAssetsService } from '@services/assets/video-assets.service';
import { MediaAssetsService } from '@services/assets/media-assets.service';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'app-organisation-eraser',
    templateUrl: './organisation-eraser.component.html',
    styleUrls: ['./organisation-eraser.component.scss'],
    providers: [
        AccommodationWizardIdsService, OrganisationService, OrganisationCustomerService, PackageService, AngieScreensService, GroupHasRoleInOrganisationService, RoleService,
        GroupService, GroupHasProfileService, ProfileService, ImageAssetsService, VideoAssetsService, FileAssetsService, MediaAssetsService
    ],
    standalone: false
})
export class OrganisationEraserComponent implements OnInit, OnDestroy {

  public title = '';

  public progressing = false;
  public done = false;
  public statusInfo = null;
  public error = null;
  public isTest = false;
  public cancel = null;
  public protocol: any = {};
  public isLive: any;

  constructor(
    private router: Router,
    private snackbar: SnackbarService,
    public dialogRef: MatDialogRef<OrganisationEraserComponent>,
    public dialogService: DialogService,
    private orgService: OrganisationService,
    private orgCustomerService: OrganisationCustomerService,
    private packageService: PackageService,
    private angieScreenService: AngieScreensService,
    private ghrInOrgService: GroupHasRoleInOrganisationService,
    private roleService: RoleService,
    private groupService: GroupService,
    private ghpService: GroupHasProfileService,
    private profileService: ProfileService,
    private imageAssetService: ImageAssetsService,
    private fileAssetService: FileAssetsService,
    private videoAssetService: VideoAssetsService,
    private mediaAssetService: MediaAssetsService,
    private ms: MessengerService,
    private accommodationWizardIdsService: AccommodationWizardIdsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isLive = this.ms.getActiveAPI() === 'live';
  }

  ngOnInit() {
    this.title = this.data && this.data.org ? this.data.org.title : '';
  }

  public ngOnDestroy() {
    this.cancel = true;
  }

  public onClose() {
    if (this.done && !this.isTest) {
      if (this.progressing) {
        this.snackbar.open('Still working, please wait!');
        return;
      }
      this.cancel = true;
      this.dialogRef.close();
      this.router.navigate(['organisations']);
    } else {
      this.cancel = true;
      this.dialogRef.close();
    }
  }

  public onRemove(test = false) {
    this.isTest = test;
    this.initProtocol();
    if (this.isTest) {
      this.removeAllData();
      return;
    }
    const random = this.generateRandom(4);
    this.dialogService.confirm(
      'Are you really sure to performe it?<br/> Enter the random code to confirm: ' + random,
      'Delete Organisation: ' + this.data.org.title,
      true).then(result => {
      if (result && result === random) {
        this.removeAllData();
      } else {
        console.log('wrong random nummber');
      }
    });
  }

  public removeAllData() {
    this.progressing = true;
    if (!this.isTest) {
      this.dialogRef.disableClose = true;
    }
    // first check constrains: can we delete it or does it have packages ?
    this.removeOrganisationCustomer().then(() => {
      this.removeIbexCustomer().then(() => {
        // get Group has role in org: ghrInOrg find Groups_GroupID and Roles_RoleID where Organisations_OrganisationID
        this.removeGhrInOrg().then(() => {
          this.removeRole().then(() => {
            this.removeGroup().then(() => {
              this.statusInfo = 'Searching Profiles ...'
              this.removeProfile().then(() => {
                this.statusInfo = 'Searching Assets ...'
                this.removeAssets().then(() => {
                  this.statusInfo = 'Removing Organisation ...';
                  this.removeByIds(this.orgService, [this.data.org.OrganisationID]).then(() => {
                    this.saveProtocol().then(() => {
                      this.dialogRef.disableClose = false;
                      this.statusInfo = '(-: *** Success *** :-)';
                      this.progressing = false;
                      this.done = true;
                    });
                  });
                });
              });
            });
          })
        });
      })
    }).catch(err => {
      this.saveProtocol(err);
    });
  };

  private removeOrganisationCustomer(): Promise<any> {
    if (!this.data.org.organisationCustomerId) {
      return Promise.resolve(true);
    }
    // if we have an angie-customer we check for remaining packages
    return this.find(this.packageService, { customerId: this.data.org.organisationCustomerId }).then(packages => {
      if (packages && packages.length) {
        this.protocol.log.push('Organisation can not be removed - remove package(s) first: ');
        packages.map(currentPackage => {
          this.protocol.log.push('Connected Package: ' + currentPackage.title);
        })
        this.error = 'Organisation is still in use'
        return Promise.reject();
      } else {
        // we can remove this customer, and will remove all connected angie-screens (customers, settings and jsons)
        return this.find(this.angieScreenService, { organisationCustomerId: this.data.org.organisationCustomerId }).then(screens => {
          const ids = [];
          screens.map(screen => {
            ids.push(screen._id);
          });
          this.protocol.angieScreens = screens;
          return this.removeByIds(this.angieScreenService, ids).then(() => {
            this.protocol.log.push('Angie screens: (' + this.protocol.angieScreens.length + ')');
            this.protocol.log.push('OrganisationCustomer: ' + this.data.org.organisationCustomerId);
            return this.removeByIds(this.orgCustomerService, [this.data.org.organisationCustomerId]);
          })
        })
      }
    });
  }

  private removeIbexCustomer() {
    if (!this.data.org.ibex3customerId) {
      return Promise.resolve(true);
    }
    return this.find(this.packageService, { customerId: this.data.org.ibex3customerId }).then(packages => {
      if (packages && packages.length) {
        this.protocol.log.push('Organisation can not be removed - remove package(s) first: ');
        packages.map(currentPackage => {
          this.protocol.log.push('Connected Package: ' + currentPackage.title);
        })
        throw Error('Organisation is still in use');
      } else {
        this.protocol.log.push('You have to remove ibex3 stuff under customers:  ' + this.data.org.ibex3customerId);
        return Promise.resolve(true);
      }
    });
  }

  private removeGhrInOrg(): Promise<any> {
    return this.find(this.ghrInOrgService, { OrganisationID: this.data.org.OrganisationID })
      .then(ghrs => {
        const promises = ghrs.map(ghr => {
          if (this.protocol.roleIds.includes(ghr.RoleID) === -1) {
            this.protocol.roleIds.push(ghr.RoleID);
          }
          this.protocol.groupIds.push(ghr.GroupID);
          this.protocol.ghrInOrgIds.push(ghr.ID);
        })
        this.protocol.log.push('Group has role in organisation: (' + this.protocol.ghrInOrgIds.length + ')');
        return Promise.all(promises).then(() => {
          return this.removeByIds(this.ghrInOrgService, this.protocol.ghrInOrgIds, true, 'ID');
        });
      });
  }

  private removeRole(): Promise<any> {
    // constrains will handle if we can delete this role.
    this.protocol.log.push('Roles (' + this.protocol.roleIds.length + ')');
    return this.removeByIds(this.roleService, this.protocol.roleIds, false, 'RoleID');
  }

  private removeGroup(): Promise<any> {
    // check if we can delete this group, assigned group-has-profiles, and profiles
    const groupIds = [];
    const promises = this.protocol.groupIds.map(groupId => {
      return this.find(this.ghrInOrgService, { GroupID: groupId }).then(ghrs => {
        if (ghrs && ghrs.length && (!this.isTest || (ghrs.length > 1 || ghrs[0].OrganisationID !== this.data.org.OrganisationID))) {
          this.protocol.log.push('not removing: group still in use: ' + groupId + ', ' + ghrs[0].groupName);
          return true;
        } else {
          groupIds.push(groupId);
          return this.find(this.ghpService, { GroupID: groupId }).then(ghProfiles => {
            ghProfiles.map(ghProfile => {
              this.protocol.profileIds.push(ghProfile.ProfileID);
            })
            return true;
          })
        }
      });
    })
    this.protocol.groupIds = groupIds;
    return Promise.all(promises).then(() => {
      this.protocol.log.push('Groups (' + groupIds.length + ')');
      return this.removeByIds(this.groupService, groupIds, false, 'GroupID');
    });
  }

  private removeProfile(): Promise<any> {
    if (!this.protocol.profileIds.length) {
      return Promise.resolve(true);
    }
    const profileIds = []
    return this.find(this.profileService, { ProfileID: { $in: this.protocol.profileIds } }).then(profiles => {
      const promises = profiles.map(profile => {
        return this.find(this.ghpService, { ProfileID: profile.ProfileID }).then(result => {
          if (!result || !result.length || (this.isTest && result.length === 1 && this.protocol.groupIds.indexOf(result[0].GroupID) > -1)) {
            this.protocol.log.push('Profile: ' + profile.email);
            this.protocol.removedProfiles.push(profile);
            profileIds.push(profile.ProfileID);
          }
          return true;
        })
      });
      return Promise.all(promises).then(() => {
        return this.removeByIds(this.profileService, profileIds);
      })
    });
  }

  private removeAssets(): Promise<any> {
    const services = {
      images: this.imageAssetService,
      files: this.fileAssetService,
      videos: this.videoAssetService,
      medias: this.mediaAssetService
    }
    const promises = Object.keys(services).map(key => {
      this.find(services[key], { OwnerOrganisationID: this.data.org.OrganisationID }).then(assets => {
        assets.map(asset => {
          this.protocol.assets[key].push(asset._id);
        })
        this.protocol.log.push(key + ': (' + this.protocol.assets[key].length + ')');
        return this.removeByIds(services[key], this.protocol.assets[key]);
      })
    })
    return Promise.all(promises);
  }

  /* helpers */

  private initProtocol() {
    this.protocol = {};
    this.statusInfo = null;
    this.error = null;
    this.protocol.title = this.title;
    this.protocol.type = 'organisation';
    this.protocol.isDeleted = true;
    this.protocol.initialData = this.data;
    this.protocol.log = [];
    this.protocol.angieScreens = [];
    this.protocol.ghrInOrgIds = [];
    this.protocol.groupIds = [];
    this.protocol.roleIds = [];
    this.protocol.profileIds = [];
    this.protocol.removedProfiles = [];
    this.protocol.pinwallMessages = [];
    this.protocol.assets = {
      images: [],
      files: [],
      videos: [],
      medias: []
    }
  }

  private find(service, query, skip = 0, documents = []): Promise<any> {
    if (this.cancel) {
      throw new Error('canceled');
    }
    let limit = 100;
    if (service.provider.endpointName === 'analytic-logs') {
      limit = 1000000
    }
    return service.find(skip, limit, query).then(result => {
      if (result && result.data && result.data.length) {
        documents = documents.concat(result.data);
        if (result.total - skip > limit) {
          return this.find(service, query, skip + limit, documents);
        }
      }
      return Promise.resolve(documents);
    });
  }

  private removeByIds(service, ids, bubbleError = false, queryField = '_id'): Promise<any> {
    if (this.cancel) {
      throw new Error('canceled');
    }
    const promises = ids.map(id => {
      if (this.cancel) {
        throw new Error('canceled');
      }
      if (this.isTest) {
        return service.get(id).catch(err => {
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('not found: ' + service.provider.endpointName + ', ' + id + ': ' + error);
          return Promise.resolve(true);
        });
      } else {
        if (bubbleError) {
          return service.remove(id);
        }
        return service.remove(id).catch(err => {
          console.log(err);
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('Error removing from: ' + service.provider.endpointName + ', ' + id + ': ' + error);
          return Promise.resolve(true);
        });
      }
    });
    return Promise.all(promises);
  }

  private generateRandom(amount) {
    const code = [];
    for (let i = 0; i < amount; i++) {
      code.push(Math.floor(Math.random() * 10));
    }
    return code.join('');
  }

  private saveProtocol(error = null): Promise<any> {
    if (error) {
      this.error = error && error.error && error.error.message ? error.error.message : error;
      this.protocol.errror = error;
    } else {
      this.protocol.success = true;
    }
    const protocol = new Models.AccommodationWizardIds();
    protocol.processedData = this.protocol;
    if (this.isTest) {
      console.log(this.protocol)
      return Promise.resolve(true);
    }
    return this.accommodationWizardIdsService.create(protocol).then(result => {
      this.snackbar.open('protocol saved to wizard data ( you find this under userManagement ')
      return Promise.resolve(true);
    });
  }

}
